export default __webpack_public_path__ + "static/media/headset.42c96374.svg";